import { render, staticRenderFns } from "./VFooterECG.vue?vue&type=template&id=608315fc&"
import script from "./VFooterECG.vue?vue&type=script&lang=js&"
export * from "./VFooterECG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports